var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.81 3.452l-7.143 6.667 34.762 35.238H0v9.524h81.429l-35 35.238 6.19 6.429L100 50.357 53.81 3.452z"
  })));
};

export default SvgArrow;